
import "waypoints/lib/noframework.waypoints"
import "waypoints/lib/shortcuts/inview"

interface WaypointInviewOptions {
  element: HTMLElement
  enter?: (direction: ("up" | "down" | "left" | "right")) => void
  entered?: (direction: ("up" | "down" | "left" | "right")) => void
  exit?: (direction: ("up" | "down" | "left" | "right")) => void
  exited?: (direction: ("up" | "down" | "left" | "right")) => void

  context?: HTMLElement
  enabled?: boolean
  horizontal?: boolean
}
declare class Inview {
  constructor(options: WaypointInviewOptions)

  // Instance Methods
  public destroy(): Waypoint
  public disable(): Waypoint
  public enable(): Waypoint
}
interface Waypoint {
  Inview: typeof Inview
}

declare global {
  interface Window {
    Waypoint: Waypoint
  }
}

export default window.Waypoint
